import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { getCalculationDocument } from 'modules/accommodations/features/reservations/api';

import { IPreviewModalData } from './../../components/ReservationInfo/InfoTabs/Documents/Modals/IPreviewModalData';

interface IProps {
  previewDocument: ({ type, reservationId, paymentId, pdfData }: IPreviewModalData) => void;
}

export const useGenerateDocumentMutation = ({ previewDocument }: IProps) => {
  const { errorToast } = useCustomToast();

  const { mutate: generateDocument, isLoading } = useMutation(getCalculationDocument, {
    onSuccess: (data, variables) => {
      previewDocument({
        type: variables.type,
        reservationId: variables.reservationId,
        paymentId: variables.paymentId,
        pdfData: data,
      });
    },
    onError: () => errorToast(),
  });

  return {
    isGenerating: isLoading,
    generateDocument,
  };
};
